import { GlSprintf, GlLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'WikiDiscussionsSignedOut',
    components: {
        GlSprintf,
        GlLink
    },
    inject: [
        'registerPath',
        'signInPath'
    ],
    props: {
        isReply: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        signedOutText () {
            return this.isReply ? __('Please %{registerLinkStart}register%{registerLinkEnd} or %{signInLinkStart}sign in%{signInLinkEnd} to reply.') : __('Please %{registerLinkStart}register%{registerLinkEnd} or %{signInLinkStart}sign in%{signInLinkEnd} to add a comment.');
        }
    }
};
